import { render, staticRenderFns } from "./wilayah.vue?vue&type=template&id=47ea60c4&scoped=true&"
import script from "./wilayah.vue?vue&type=script&lang=js&"
export * from "./wilayah.vue?vue&type=script&lang=js&"
import style0 from "./wilayah.vue?vue&type=style&index=0&id=47ea60c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea60c4",
  null
  
)

export default component.exports